import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetReservationRequestsResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useGetReservationRequests = () => {
  return useQuery({
    queryKey: ["reservation-requests", "admin"],
    queryFn: async (): Promise<GetReservationRequestsResponseDto> => {
      const response = await apiFetch("api/admin/reservation-requests");
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
  });
};
